import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface Agency {
  id: string;
  name: string;
}

@Component({
  selector: 'app-agency',
  templateUrl: './agency-dialog.component.html',
  styleUrls: ['./agency-dialog.component.scss'],
})

export class AgencyDialogComponent {
  agency: Agency;
  constructor(
    public dialogRef: MatDialogRef<AgencyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { agency: Agency; isEdit: boolean }
  ) {
    this.agency = data.isEdit ? { ...data.agency } : { id: '', name: '' };
  }

  isValid(): boolean {
    return !!this.agency.name.trim();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.agency.name = this.agency.name.trim();
    this.dialogRef.close(this.agency);
  }
}
